import React from 'react';
import './About.css';

const About = () => {
    return (
        <section id='about' className="about-container">
            <h2>About Us</h2>
            <p>
            We help students achieve their dreams of studying abroad by providing
            comprehensive information on universities, courses, scholarships, and
            student visas.
            </p>
        </section>
    );
}

export default About;
